import React from "react";
import {Link} from "react-scroll";
export default function Navbar() {
  return (  
    <header className="bg-gray-800 md:sticky top-0 z-10">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <a className="title-font font-medium text-white mb-4 md:mb-0">
          <a href="#about" className="ml-3 text-xl">
            Hanane Ellioua
          </a>
        </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
        {/*SCROLL TO PROJECTS*/}
        <Link 
          className="mr-5 hover:text-white"
          to="projects"
          spy={true}
          smooth={true}
          hashSpy={true}
          offset={50}
          duration={500}
          spyThrottle={500}>
              Diplômes
        </Link>

        <Link 
          className="mr-5 hover:text-white"
          to="articles"
          spy={true}
          smooth={true}
          hashSpy={true}
          offset={50}
          duration={500}
          spyThrottle={500}>
              Articles
        </Link>
        <Link 
          className="mr-5 hover:text-white"
          to="videos"
          spy={true}
          smooth={true}
          hashSpy={true}
          offset={50}
          duration={500}
          spyThrottle={500}>
              Cours
        </Link>
        </nav>
      </div>
    </header>
  );
}


// WEBPACK FOOTER //
// ./src/Components/navbar.js